/** Standalone route for students past enrollment (the backfill). */
export const POST_PROGRAM_VERIFICATION_PATH =
  "/authorizations/post-program-verification";

/** Analytics: fired after the signing callable succeeds. No PII. */
export const FCRA_AUTHORIZATION_COMPLETED_EVENT =
  "Enrollment Wizard - FCRA Authorization Completed";
